<template>
<div>
  <!-- 线下支付弹框 -->
  <el-dialog append-to-body :title="rowData.flag==2?'线下确认':'线下支付'" :visible.sync="dialog"  @close="closeDialog" :close-on-click-modal="false" width="1000px" center>
       <el-form :inline="true" :rules="rules" :model="addForm" ref="addForm" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class=" addressBox">
            <div class="item">
              <h4 class="title">
                <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>付款方</span>
                <!-- <el-button type="primary" @click="xuanzeFn" style="margin-left:9px">选择</el-button> -->
              </h4>
              <div>
                <el-form-item label="持卡人:" prop="payCardholder" >
                  <el-input  placeholder="" class="disabled"  :readonly="true"  v-model.trim="addForm.payCardholder" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="开户银行:" prop="payBank" >
                  <el-input  placeholder="" class="disabled"  :readonly="true"  v-model.trim="addForm.payBank" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="银行卡号:" class="disabled" prop="payBankNo" >
                  <el-input   placeholder="" :readonly="true" maxlength=""  v-model.trim="addForm.payBankNo" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="付款金额:"  class="jiage">
                  <el-input    placeholder="" class="disabled" maxlength="20" v-model="addForm.transMoney" :readonly="true" style="width:220px;"></el-input>
                  <span class="danwei">元</span>
                </el-form-item><br>
                <el-form-item label="付款流水号:" prop="sequencecode" >
                  <el-input    placeholder="" :class="{disabled:rowData.flag==2}" maxlength="20" v-model="addForm.sequencecode" :readonly="rowData.flag==2" style="width:220px;"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="item">
              <h4 class="title">
                <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>收款方</span>
              </h4>
              <div>
                <el-form-item label="持卡人:" prop="recCardholder" >
                  <el-input  placeholder="" class="disabled"  :readonly="true" v-model.trim="addForm.recCardholder" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="开户银行:" prop="recBank" >
                  <el-input  placeholder="" class="disabled"  :readonly="true" v-model.trim="addForm.recBank" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="银行卡号:" prop="recBankNo" >
                  <el-input   placeholder="" class="disabled" :readonly="true"  v-model.trim="addForm.recBankNo" style="width:220px;"></el-input>
                </el-form-item>
                <el-form-item label="收款流水号:" prop="recSequencecode" v-if="rowData.flag==2">
                  <el-input    placeholder="" maxlength="20" v-model="addForm.recSequencecode"  style="width:220px;"></el-input>
                </el-form-item>
              </div>
            </div>
        </div>
        <div class="box"  v-if="dialog&&rowData.flag==1" style="margin-top:30px">
          <div class="imgBox" >
            <uploadImgs :imgList.sync='imgFKPZ'   ></uploadImgs>
            <h6><span class="red">*</span>付款凭证</h6>
          </div>
        </div>
         <div class="box"  v-if="dialog&&rowData.flag==2">
          <div class="imgBox" style="    margin-top: 20px;">
              <el-image :src="addForm.fileUrlOSS"  :preview-src-list="getSrcList(0)" style="height:240px"></el-image>
            <h6><span class="red">*</span>付款凭证</h6>
          </div>
          <div class="imgBox" >
            <uploadImgs :imgList.sync='imgSKPZ'   ></uploadImgs>
            <h6 style="margin:0">收款凭证</h6>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="dialog=false">取消</el-button>
      <el-button type="primary" @click="addSave('addForm')">确 定</el-button>
    </span>
  </el-dialog>

</div>
</template>

<script>
import { platformAcclist, tAccountList, offlinePay, offlineSettlement, tOfflineReceipt } from '@/api/consignment'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import uploadImgs from '@/components/uploadImgs.vue'
import { compressImages } from '@/utils/compressImages'
export default {
  name: 'offlinePayment',
  components: {
    uploadImgs
  },
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      addForm: {},
      dialog: true,
      yinhangList: [],
      rules: {
        sequencecode: [
          { required: true, message: '请输入银行流水号', trigger: 'blur' }
        ]
      },
      imgFKPZ: [],
      imgSKPZ: [],
      imgfile: new FormData()
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (this.rowData.flag == 1) {
      this.$set(this.addForm, 'transMoney', this.rowData.totalAmount)
      platformAcclist({ accountClassify: 2 }).then(res => {
        this.addForm.platformAccountId = res[0].id
        this.addForm.platformZxAccNo = res[0].zxAccNo
        this.addForm.platformZxAccNm = res[0].zxAccNm
        this.$set(this.addForm, 'recCardholder', res[0].cardholder)
        this.$set(this.addForm, 'recBank', res[0].openingBank)
        this.$set(this.addForm, 'recBankNo', res[0].bankAccount)
        this.addForm.upSettlementId = this.rowData.id
        this.addForm.settlementNo = this.rowData.settlementNo
      })
      tAccountList().then(res => {
        if (res[0].cardholder) {
          this.$set(this.addForm, 'payCardholder', res[0].cardholder)
          this.$set(this.addForm, 'payBank', res[0].openingBank)
          this.$set(this.addForm, 'payBankNo', res[0].bankAccount)
        } else {
          this.$alert('请到资金账户绑定银行卡', '系统提示')
        }
      })
    } else {
      tOfflineReceipt({ settlementNo: this.rowData.settlementNo }).then(res => {
        this.addForm = res
        this.addForm.upSettlementId = this.rowData.id
        delete this.addForm.id
      })
    }
  },
  methods: {
    getSrcList (index) {
      let arr = [this.addForm.fileUrlOSS]
      return arr.slice(index).concat(arr.slice(0, index))
    },
    addSave () {
      if (this.rowData.flag == 1) {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            console.log(this.addForm)
            if (this.imgFKPZ.length == 0) {
              this.$alert('请上传付款凭证', '系统提示')
              return
            }
            let that = this
            compressImages(this.imgFKPZ, {
              width: 1000
            }).then(result => {
              if (result[0]) {
                that.imgfile.set('file', result[0])
              }
              this.imgfile.set('param', JSON.stringify(this.addForm))
              const loading = that.$loading({
                lock: true,
                text: '正在处理...'
              })
              offlinePay(that.imgfile).then(res => {
                loading.close()
                that.$message({
                  message: '添加成功',
                  type: 'success'
                })
                that.dialog = false
                that.$parent.searchFn()
              }).catch(error => {
                that.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
            })
          }
        })
      } else {
        let that = this
        compressImages(this.imgFKPZ, {
          width: 1000
        }).then(result => {
          if (result[0]) {
            that.imgfile.set('file', result[0])
          }
          console.log(this.addForm)
          this.imgfile.set('param', JSON.stringify(this.addForm))
          const loading = that.$loading({
            lock: true,
            text: '正在处理...'
          })
          offlineSettlement(that.imgfile).then(res => {
            loading.close()
            that.$message({
              message: '添加成功',
              type: 'success'
            })
            that.dialog = false
            that.$parent.searchFn()
          }).catch(error => {
            that.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        })
      }
    },
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.addressBox{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px dashed #ddd;
  padding-bottom: 10px;
  .item{
    width: 50%;
  }
}
 .box{
    display: flex;
    justify-content: space-between;
     width: 85%;
    margin: 0 auto;
    .imgBox{
      display: flex;
      flex-direction: column;
      width: 386px;
      height: 320px;
      /deep/.el-upload--picture-card{
        width: 386px;
        height: 240px;
      }
    }
    h6{
      text-align: center;
    }
    /deep/.el-upload--picture-card {
      background-image: url(../../../../assets/images/upload1.png);
    }
  }
</style>
